/**
 * Created by pajicv on 9/25/18.
 */

import React from 'react';
import AddButton from '../components/ProjectOverview/CreateProjectButton';
import ProjectListManager from '../components/ProjectOverview/ProjectListManager';
import * as routes from './routes';
import { createEmptyProject, initProject, initCycle, deleteProject, getTasks } from '../firebase/db';
import OverlayContainer from '../components/Overlay/OverlayContainer';
import OverlayLevel1 from '../components/Overlay/OverlayLevel1';
import ProjectMain from './ProjectSetup/ProjectMain.enhancer';
import { MANAGER_ROLE, CO_MANAGER_ROLE, WORKER_ROLE } from '../utils/constants';
import TaskDashboard from '../components/Tasks/TasksDashboard';
import { toast } from 'react-toastify';
import swal from 'sweetalert2';
const isSetupCompleted = (project) => {
    const { title, targetGroups, useCases, members } = project;
    return title
        && targetGroups
        && useCases
        && members
        && (Object.keys(targetGroups).length > 0)
        && (Object.keys(useCases).length > 0)
        && (Object.keys(members).length > 0);
};

class Dashboard extends React.Component {

    state = {
        selectedProject: null,
        selectedCycle: null,
        selectedTask: null,
        isProjectSetup: false,
        isViewTasks: false,
        role: '',
        activeLayout: '#grid',
        taskDocumentTagsOpened: false
    };

    handleChangeActiveLayout = (activeLayout) => {
        this.setState({ activeLayout });
    };

    handleCreateProjectButtonClick = (e) => {
        const { auth } = this.props;
        const projectId = createEmptyProject();
        initProject(projectId, auth.email)
            .then(() => {
                //this.props.history.push(routes.PROJECT_SETUP, { projectId });
                this.setState({ isProjectSetup: true, selectedProject: projectId });
                window.location.hash = 'overlay-project-setup';
            });
    };

    handleCreateUXCycle = (projectId, cycleId) => {
        const { history, auth: { email }, userProjects } = this.props;
        if (cycleId) {
            this.setState({ selectedProject: projectId, selectedCycle: cycleId, role: MANAGER_ROLE });
            window.location.hash = 'overlay-cycles';
            return;
        }
        if (userProjects.manager && userProjects.manager[projectId]) {//.cycles || userProjects['co-manager'][projectId].cycles) {
            if (userProjects.manager[projectId].cycles) {
                cycleId = Object.keys(userProjects.manager[projectId].cycles).pop();
                window.location.hash = 'overlay-cycles';
                //history.push(routes.PROJECT_CYCLES, { projectId, cycleId });
                this.setState({ selectedProject: projectId, selectedCycle: cycleId, role: MANAGER_ROLE });
            } else {
                initCycle(projectId, email)
                    .then((newCycleId) => {
                        //history.push(routes.PROJECT_CYCLES, { projectId, cycleId: newCycleId });
                        this.setState({ selectedProject: projectId, selectedCycle: cycleId, role: MANAGER_ROLE });
                        window.location.hash = 'overlay-cycles';
                    });
            }
        } else if (userProjects['co-manager'] && userProjects['co-manager'][projectId] && userProjects['co-manager'][projectId].cycles) {
            cycleId = Object.keys(userProjects['co-manager'][projectId].cycles).pop();
            window.location.hash = 'overlay-cycles';
            //history.push(routes.PROJECT_CYCLES, { projectId, cycleId });
            this.setState({ selectedProject: projectId, selectedCycle: cycleId, role: CO_MANAGER_ROLE });
        }
    };

    deleteProject = (projectId) => {
        const { auth: { email }, userProjects } = this.props;
        swal({
            title: `Wollen Sie wirklich das Projekt ${userProjects['manager'][projectId].title || ''} löschen?`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#54be89',
            cancelButtonColor: '#ef6920',
            confirmButtonText: 'OK',
            cancelButtonText: 'CANCEL'
        }).then((result) => {
            if (result.value) {
                deleteProject(projectId, email)
                    .then(() => {
                        return swal(
                            'Deleted!',
                            'success'
                        )
                    })
                    .catch(console.log);
            }
        });
    };

    handleContinueSetup = (projectId) => {
        const { history } = this.props;
        //history.push(routes.PROJECT_SETUP, { projectId });
        this.setState({ isProjectSetup: true, selectedProject: projectId });
        window.location.hash = 'overlay-project-setup';
    };

    handleWorkerViewTasks = (projectId, cycleId, numberOfTasks, email) => {
        const { history, userProjects } = this.props;
        if (numberOfTasks === 0) {
            toast.error("Keine Tasks zugewiesen!", {
                position: "top-center",
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
            });
        } else if (window.location.hash === '#list') {
            if (cycleId) {
                this.setState({ selectedProject: projectId, selectedCycle: cycleId, isViewTasks: true });
                window.location.hash = '#overlay-tasks';
            }
        } else {
            this.setState({ selectedProject: projectId, isViewTasks: true });
            window.location.hash = '#overlay-tasks';
        }
    };

    handleWorkerViewTasksv2 = (projectId, email) => {
        if (email) {
            this.setState({ selectedProject: projectId, isViewTasks: true, assignedTo: email });
            window.location.hash = '#overlay-tasks';
        } else {
            this.setState({ selectedProject: projectId, isViewTasks: true, assignedTo: email });
            window.location.hash = '#overlay-tasks';
        }
    }

    handleOverlayClose = () => {
        const { activeLayout } = this.state;
        window.location.hash = activeLayout;
        this.setState({ selectedProject: null, selectedCycle: null });
    };

    handleProjectSetupOverlayClose = () => {
        const { auth: { email }, userProjects } = this.props;
        const { activeLayout, selectedProject } = this.state;
        window.location.hash = activeLayout;
        const project = userProjects.manager[selectedProject];
        if (isSetupCompleted(project) && !project.cycles) {
            initCycle(selectedProject, email);
        }
        this.setState({ selectedProject: null, isProjectSetup: false });
    };

    handleTaskOverlayClose = () => {
        const { activeLayout } = this.state;
        window.location.hash = activeLayout;
        this.setState({ selectedProject: null, selectedCycle: null, isViewTasks: false });
    };

    handleDialogOpen = (taskDocumentTagsOpened) => {
        this.setState({ taskDocumentTagsOpened });
    };

    hanldeToggleTags = (taskDocumentTagsOpened) => {
        this.setState({ taskDocumentTagsOpened });
    };

    render() {
        const { userProjects } = this.props;
        const { selectedProject, assignedTo, selectedCycle, selectedTask, role, isProjectSetup, isViewTasks, activeLayout, taskDocumentTagsOpened } = this.state;
        return (
            <div>
                <ProjectListManager
                    projects={userProjects}
                    onCreateUXCycle={this.handleCreateUXCycle}
                    onContinueSetup={this.handleContinueSetup}
                    onDeleteProject={this.deleteProject}
                    onWorkerViewTasks={this.handleWorkerViewTasks}
                    onWorkerViewTasksv2={this.handleWorkerViewTasksv2}
                    onLayoutChange={this.handleChangeActiveLayout}
                    selectedView={activeLayout}
                />
                <AddButton style={{ position: 'fixed' }} onClick={this.handleCreateProjectButtonClick} title="Projekt" />
                {(Boolean(selectedProject) && Boolean(selectedCycle) && window.location.hash === '#overlay-cycles')
                    && <OverlayContainer projectId={selectedProject} cycleId={selectedCycle} onOverlayClose={this.handleOverlayClose} role={role} overlayLevel={0} />}
                {isProjectSetup && Boolean(selectedProject) && window.location.hash === '#overlay-project-setup' &&
                    <React.Fragment>
                        <OverlayLevel1
                            onClickOutsideOverlay={this.handleProjectSetupOverlayClose}
                            onClose={this.handleProjectSetupOverlayClose}
                            disableOnClickOutside={taskDocumentTagsOpened}
                            open={isProjectSetup && Boolean(selectedProject) && window.location.hash === '#overlay'}
                        >
                            <ProjectMain projectId={selectedProject}
                                onClose={this.handleProjectSetupOverlayClose}
                                onDialogOpen={this.handleDialogOpen}
                            />
                        </OverlayLevel1>
                    </React.Fragment>
                }
                {isViewTasks && (
                    <React.Fragment>
                        <OverlayLevel1 open={(window.location.hash === '#overlay-tasks')} onClose={this.handleTaskOverlayClose} onClickOutsideOverlay={this.handleTaskOverlayClose} disableOnClickOutside={taskDocumentTagsOpened}>
                            <TaskDashboard overlayLevel={1} location={{ state: { projectId: selectedProject, cycleId: selectedCycle, assignedTo: assignedTo } }} onTagsOpen={this.hanldeToggleTags} />
                        </OverlayLevel1>
                    </React.Fragment>
                )}
            </div>
        );
    }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/routes/Dashboard.js